


























































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { ListItem } from "@/store/modules/delayCodes/utils";
import GuidedListItem from "@/components/GuidedList/GuidedListItem.vue";
import store from "@/store";
import { MutationsTypes } from "../../store/modules/delayCodes/mutations";
import { ListToBeDisplayed } from "../../store/modules/delayCodes/utils";

@Component({
  components: {
    GuidedListItem
  }
})
export default class GuidedList extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(Array) readonly items!: ListItem[];
  @Prop(Object) readonly selectedItem!: ListItem;
  @Prop(Number) readonly listType!: number;
  @Prop(Boolean) readonly shouldDisplayDoorsStatus!: boolean;

  get searchedText(): string {
    return store.state.delayCodes.searchedText;
  }

  set searchedText(text: string) {
    store.commit.delayCodes[MutationsTypes.SET_SEARCHED_TEXT](text);
  }

  get itemsDisplayed(): ListItem[] {
    return this.items
      .filter(it => {
        // Filter on Doors Status if on Process
        if (this.listType === ListToBeDisplayed.Process) {
          switch (this.selectedDoorsSelection) {
            case 0:
              return true;
            case 1:
              return (
                it.value[0].toLowerCase() >= "d" &&
                it.value[0].toLowerCase() <= "w"
              );
            case 2:
              return it.value[0].toLowerCase() > "w";
            default:
              return true;
          }
        } else {
          return true;
        }
      })
      .filter(it => {
        if (it.subItemOf === undefined) {
          return true;
        } else {
          return (
            store.state.delayCodes.openedStakeholderGroups.findIndex(
              itOpened => itOpened === it.subItemOf
            ) !== -1
          );
        }
      });
  }

  selectedDoorsSelection: number | null = null;

  selectDoorsSelection(value: number | null) {
    this.selectedDoorsSelection = value;
  }

  @Watch("listType")
  onListeTypeChanged() {
    (this.$refs["main-list-container"] as HTMLDivElement).scrollTop = 0;
  }

  unfocusTextfield() {
    (this.$refs["searchTextField"] as HTMLInputElement).blur();
  }
}
